export { VpAddCardDialog } from './VpAddCardDialog';



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpAddCardDialog/index.js